import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';

import * as getters from './getters';

const mutations = {
  SET_BRAND(state, payload) {
    state.brand = payload;
  },
};

const state = () => ({
  brand: PROJECT_BRANDS.reverse,
});

export default {
  namespaced: true,
  mutations,
  getters,
  state,
};
